import { render, staticRenderFns } from "./slist.vue?vue&type=template&id=90fe90dc&scoped=true&"
import script from "./slist.vue?vue&type=script&lang=js&"
export * from "./slist.vue?vue&type=script&lang=js&"
import style0 from "./slist.vue?vue&type=style&index=0&id=90fe90dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fe90dc",
  null
  
)

export default component.exports